import { useState, useEffect } from 'react';
import { SellerMyPage } from './seller/SellerMyPage';
import { DesktopSellerMyPage } from './desktop/DesktopSellerMyPage';

export function ResponsiveSellerMyPage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <SellerMyPage /> : <DesktopSellerMyPage />;
}